export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-android-2.a85a0589.svg";